import { request, useQuery } from '@applyboard/ui-utils';
import { z } from 'zod';

const companyInfoResponseSchema = z.object({
  company_name: z.string(),
  intake_form_enabled: z.boolean(),
  assigned_staff: z.number().nullable(),
  logo_url: z.string().nullable(),
});

export const useCompanyInfo = (agentId: string) => {
  const { isFetching, isSuccess, data, isLoading, isError, error } = useQuery(
    ['companyInfo', { pkg: 'ab-student-intake-form' }],
    async () =>
      await request(`/api/agencies/${agentId}/company_info`, {
        method: 'GET',
        schema: companyInfoResponseSchema,
      }),
    {
      enabled: !!agentId,
    },
  );

  return {
    companyInfo: isSuccess ? data : null,
    isFetchingCompanyInfo: isFetching,
    isLoadingCompanyInfo: isLoading,
    companyInfoError: error,
    isFetchCompanyInfoError: isError,
  };
};
